import { A as ka, b as $a, C as Ua, F as Ba, d as Ha, L as qa, N as Ka, a as Va, R as Qa, T as ja, U as Ga, c as za, e as Wa } from "./RootLayout-BR2Z2jPU.js";
import { f as at } from "./definitionToFormily-DHvoqVE0.js";
import { B as Ya, C as Xa, e as Za, c as er, g as tr, d as nr, h as sr, b as ar, t as rr, a as ir, u as or } from "./definitionToFormily-DHvoqVE0.js";
import { useMemo as Q, useEffect as ne, useSyncExternalStore as rt, useCallback as P, useRef as E, useState as R, useLayoutEffect as Ge, Fragment as it } from "react";
import { E as ot, H as ct, T as lt, U as dt, V as ut, W as mt, X as pt } from "./FormView-CWSNCHG6.js";
import { F as lr, b as dr, L as ur, N as mr, P as pr, $ as hr, Q as fr, a0 as yr, ad as gr, ac as _r, a1 as br, ae as vr, af as wr, _ as Sr, S as Nr, m as Tr, e as Cr, o as Rr, j as Fr, A as Pr, O as Er, z as Or, Y as Lr, M as Mr, Z as Ar, g as xr, i as Ir, a2 as Dr, ag as kr, l as $r, a7 as Ur, a6 as Br, y as Hr, ab as qr, aa as Kr, R as Vr, D as Qr, J as jr, t as Gr, C as zr, a5 as Wr, a4 as Jr, k as Yr, d as Xr, f as Zr, h as ei, n as ti, B as ni, q as si, s as ai, a3 as ri, K as ii, a9 as oi, r as ci, c as li, p as di, w as ui, a8 as mi, G as pi, u as hi, a as fi, I as yi, v as gi, x as _i } from "./FormView-CWSNCHG6.js";
import { l as vi, j as wi, o as Si, a as Ni, g as Ti, n as Ci, i as Ri, r as Fi, e as Pi, s as Ei, f as Oi, d as Li, u as Mi, b as Ai, c as xi, h as Ii, k as Di, m as ki } from "./templateResolver-BchYA4i9.js";
import { b as ht } from "./use-definition-0yWcQDPI.js";
import { E as Ui, s as Bi, u as Hi, a as qi, f as Ki, e as Vi, d as Qi, c as ji } from "./use-definition-0yWcQDPI.js";
import { z as $, n as ft, v as yt, r as gt, x as _t, N as qe, d as A, g as ze } from "./fetcher-CUYp7JR1.js";
import { w as zi, c as Wi, b as Ji, o as Yi, m as Xi, j as Zi, e as eo, a as to, f as no, h as so, i as ao, l as ro, p as io, t as oo, k as co, q as lo, y as uo, s as mo, u as po } from "./fetcher-CUYp7JR1.js";
import { E as fo, F as yo, a as go, I as _o, b as bo, L as vo, Q as wo, S as So, T as No, g as To, t as Co, c as Ro, u as Fo } from "./TabsLayout-CoWsxTaz.js";
import { A as Eo, D as Oo, K as Lo, S as Mo, c as Ao, l as xo, h as Io, k as Do, p as ko, g as $o, a as Uo, m as Bo, b as Ho, i as qo, d as Ko, e as Vo, s as Qo, n as jo, f as Go, o as zo, j as Wo, w as Jo } from "./kv-qGnj-NLd.js";
import { L as Xo, u as Zo, a as ec } from "./loading-status-Bznbx7a4.js";
import { L as nc, T as sc, a as ac, u as rc } from "./TabListView-DTlHiJjA.js";
import { D as oc, T as cc, b as lc, q as dc, a as uc, d as mc, x as pc, l as hc, n as fc, p as yc, o as gc, z as _c, k as bc, g as vc, c as wc, e as Sc, v as Nc, i as Tc, j as Cc, m as Rc, h as Fc, w as Pc, r as Ec, y as Oc, f as Lc, s as Mc, t as Ac } from "./DataGrid-Cy1qOpyR.js";
import { P as Ic } from "./PopupForm-ltuG3xhx.js";
import { a as kc, c as $c, e as Uc } from "./cascadeOptions-BRM6N5wX.js";
import { jsx as s, jsxs as d, Fragment as We } from "react/jsx-runtime";
import { useInfiniteQuery as Je, useQuery as Re, useQueryClient as Fe, useMutation as Ie } from "@tanstack/react-query";
import { useNavigate as bt, useParams as vt, useRouterState as wt } from "@tanstack/react-router";
import { Flex as w, Spin as ve, Input as Ye, Typography as v, Badge as St, message as te, Button as I, Mentions as Nt, Avatar as Tt, Modal as De, Dropdown as Ct, AutoComplete as Rt, Select as Ft } from "antd";
import "idb";
import { create as Pt } from "zustand";
import { persist as Et, createJSONStorage as Ot } from "zustand/middleware";
import k from "dayjs";
import Lt from "dayjs/plugin/relativeTime";
import { CloseOutlined as Xe, PaperClipOutlined as Mt, SendOutlined as At, UserOutlined as xt, ArrowLeftOutlined as It, InfoCircleOutlined as Dt, PushpinOutlined as ke, ArrowDownOutlined as kt, PushpinFilled as $e, MoreOutlined as $t, RollbackOutlined as Ut, CloseCircleOutlined as Bt, LoadingOutlined as Ht, CheckOutlined as be } from "@ant-design/icons";
function Pe() {
  const e = $((t) => {
    var n;
    return (n = t.profile) == null ? void 0 : n.id;
  });
  return Q(() => {
    if (e != null && Number.isFinite(Number(e)))
      return Number(e);
    const t = ot();
    if (!t)
      return;
    const n = ct(t);
    if (!n)
      return;
    const a = n.userID, r = typeof a == "number" ? a : Number(a);
    return Number.isFinite(r) && r > 0 ? r : void 0;
  }, [e]);
}
function Pa(e) {
  const t = $((a) => a.setAccess), [n] = ht("/auth/access", {
    abortSignal: e,
    staleTime: 300 * 1e3,
    retry: 2
  });
  return ne(() => {
    n.data && (t({
      permissions: n.data.permissions,
      rules: n.data.rules
    }), ft(n.data));
  }, [n.data, t]), at(
    {
      data: n.data,
      error: n.error,
      isLoading: n.isLoading,
      isValidating: n.isFetching
    },
    { code: "access", description: "Access rules" }
  );
}
function qt() {
  const e = $((n) => n.access), t = $(
    (n) => {
      var a;
      return n.isSuperAdmin ?? ((a = n.profile) == null ? void 0 : a.is_super_admin);
    }
  );
  return Q(() => {
    const n = !!t;
    return {
      canUiRoute: (a) => {
        var r;
        return pt(a, (r = e == null ? void 0 : e.rules) == null ? void 0 : r.uiRoute, n);
      },
      canPath: (a) => {
        var r;
        return mt(a, (r = e == null ? void 0 : e.rules) == null ? void 0 : r.path, n);
      },
      canElement: (a) => ut(a, e == null ? void 0 : e.rules, n),
      canEntityMutate: (a, r) => dt({
        isSuperAdmin: n,
        permissions: e == null ? void 0 : e.permissions,
        entityName: a,
        operation: r
      }),
      canEntityRead: (a) => lt({
        isSuperAdmin: n,
        permissions: e == null ? void 0 : e.permissions,
        entityName: a
      })
    };
  }, [e, t]);
}
function Kt(e) {
  return window.addEventListener(qe, e), window.addEventListener("storage", e), () => {
    window.removeEventListener(qe, e), window.removeEventListener("storage", e);
  };
}
function Ea() {
  return rt(Kt, gt, () => _t);
}
function Oa(e) {
  return e === yt;
}
const Le = {}, Te = {
  enc: (e) => btoa(String.fromCharCode(...new Uint8Array(e))),
  dec: (e) => {
    const t = atob(e), n = new Uint8Array(t.length);
    for (let a = 0; a < t.length; a++)
      n[a] = t.charCodeAt(a);
    return n.buffer;
  }
}, La = async (e, t) => {
  if ((t == null ? void 0 : t.__enc) !== "v1")
    return t;
  const n = await Ze(e);
  if (!n)
    return null;
  const a = new Uint8Array(Te.dec(t.iv)), r = Te.dec(t.ct), l = await crypto.subtle.decrypt({ name: "AES-GCM", iv: a }, n, r);
  return new TextDecoder().decode(l);
}, Ma = async (e, t) => {
  const n = await Ze(e);
  if (!n)
    return t;
  const a = new TextEncoder().encode(t), r = crypto.getRandomValues(new Uint8Array(12)), l = await crypto.subtle.encrypt({ name: "AES-GCM", iv: r }, n, a);
  return { __enc: "v1", iv: Te.enc(r.buffer), ct: Te.enc(l) };
}, Ze = async (e) => {
  if (Le[e])
    return Le[e];
  const t = new TextEncoder(), n = await crypto.subtle.digest("SHA-256", t.encode(e));
  return Le[e] = await crypto.subtle.importKey(
    "raw",
    n,
    { name: "AES-GCM" },
    !1,
    ["encrypt", "decrypt"]
  );
}, Aa = (e, t) => {
  e().catch((n) => {
    console.warn(t, n);
  });
}, Vt = "chat/rooms/create", x = "/api/chat";
async function Ke(e) {
  return A(`${x}/rooms`, {
    method: "POST",
    body: JSON.stringify(e)
  });
}
async function Qt(e) {
  var a;
  const t = new URLSearchParams();
  e != null && e.page && t.set("page", String(e.page)), e != null && e.limit && t.set("limit", String(e.limit)), e != null && e.type && t.set("type", e.type), (a = e == null ? void 0 : e.q) != null && a.trim() && t.set("q", e.q.trim());
  const n = t.toString();
  return A(`${x}/rooms${n ? `?${n}` : ""}`);
}
async function jt(e) {
  return A(`${x}/rooms/${e}`);
}
async function Gt(e, t) {
  return A(`${x}/rooms/${e}/messages`, {
    method: "POST",
    body: JSON.stringify(t)
  });
}
async function zt(e, t) {
  const n = new URLSearchParams();
  t != null && t.before && n.set("before", t.before), t != null && t.limit && n.set("limit", String(t.limit));
  const a = n.toString();
  return A(
    `${x}/rooms/${e}/messages${a ? `?${a}` : ""}`
  );
}
async function Wt(e) {
  return A(`${x}/rooms/${e}/members`);
}
async function Jt(e) {
  return A(`${x}/rooms/${e}/typing`);
}
async function Me(e, t) {
  await A(`${x}/rooms/${e}/typing`, {
    method: "POST",
    body: JSON.stringify({ typing: t })
  });
}
async function Yt(e, t) {
  await A(`${x}/rooms/${e}/read`, {
    method: "POST",
    body: JSON.stringify({ event_id: t })
  });
}
async function Xt(e) {
  return A(`${x}/rooms/${e}/pins`);
}
async function Zt(e, t) {
  await A(`${x}/rooms/${e}/pins`, {
    method: "POST",
    body: JSON.stringify({ event_id: t })
  });
}
async function en(e, t) {
  await A(`${x}/rooms/${e}/pins`, {
    method: "DELETE",
    body: JSON.stringify({ event_id: t })
  });
}
async function tn(e) {
  const t = e.trim();
  if (t.length < 2)
    return [];
  const n = await A(
    `${x}/users/search?q=${encodeURIComponent(t)}`
  );
  return (n == null ? void 0 : n.data) ?? [];
}
async function nn(e) {
  const t = new FormData();
  t.append("file", e);
  const n = ze(), a = await fetch("/api/file/upload", {
    method: "POST",
    body: t,
    credentials: "include",
    headers: {
      ...n ? { Authorization: `Bearer ${n}` } : {},
      "X-Client": "@neu/libui"
    }
  }), r = await a.text();
  if (!a.ok)
    throw new Error(r || `Upload failed (${a.status})`);
  const l = r ? JSON.parse(r) : null, c = l == null ? void 0 : l.id;
  if (typeof c != "number")
    throw new Error("Upload response missing media id");
  return c;
}
const sn = 20;
function Ve(e) {
  var n;
  const t = ((n = e.last_message) == null ? void 0 : n.timestamp) ?? e.updated_on;
  return new Date(t).getTime();
}
function an(e) {
  var c, m, y;
  const t = $((p) => p.loggedIn), n = (e == null ? void 0 : e.limit) ?? sn, a = ((c = e == null ? void 0 : e.q) == null ? void 0 : c.trim()) ?? "", r = Je({
    queryKey: ["chat", "rooms", { limit: n, type: e == null ? void 0 : e.type, q: a }],
    queryFn: ({ pageParam: p }) => Qt({
      page: p,
      limit: n,
      type: e == null ? void 0 : e.type,
      q: a || void 0
    }),
    initialPageParam: 1,
    getNextPageParam: (p) => {
      if (!(p.page * n >= p.total))
        return p.page + 1;
    },
    staleTime: 15e3,
    refetchInterval: t ? 8e3 : !1
  });
  return {
    conversations: Q(() => {
      var O;
      const p = ((O = r.data) == null ? void 0 : O.pages.flatMap((N) => N.data)) ?? [], S = /* @__PURE__ */ new Set();
      return [...p.filter((N) => S.has(N.id) ? !1 : (S.add(N.id), !0))].sort(
        (N, b) => Ve(b) - Ve(N)
      );
    }, [r.data]),
    total: ((y = (m = r.data) == null ? void 0 : m.pages[0]) == null ? void 0 : y.total) ?? 0,
    isLoading: r.isLoading,
    isFetchingNextPage: r.isFetchingNextPage,
    hasNextPage: r.hasNextPage ?? !1,
    fetchNextPage: r.fetchNextPage
  };
}
function rn(e) {
  const t = $((n) => n.loggedIn);
  return Re({
    queryKey: ["chat", "rooms", e, "detail"],
    queryFn: () => jt(e),
    enabled: !!e && t,
    staleTime: 2e3,
    refetchInterval: e && t ? 4e3 : !1
  });
}
function et(e) {
  const t = $((n) => n.loggedIn);
  return Re({
    queryKey: ["chat", "rooms", e, "members"],
    queryFn: () => Wt(e),
    enabled: !!e && t,
    staleTime: 6e4
  });
}
const on = "neu-chat", Ce = Pt()(
  Et(
    (e, t) => ({
      lastOpenRoomID: null,
      typingUsers: {},
      optimisticMessages: {},
      setLastOpenRoomID: (n) => {
        e({ lastOpenRoomID: n });
      },
      addTypingUser: (n, a) => {
        const { typingUsers: r } = t(), l = r[n] ?? /* @__PURE__ */ new Set();
        l.add(a), e({ typingUsers: { ...r, [n]: l } });
      },
      removeTypingUser: (n, a) => {
        const { typingUsers: r } = t(), l = r[n];
        l && (l.delete(a), e({ typingUsers: { ...r, [n]: l } }));
      },
      addOptimisticMessage: (n, a) => {
        const { optimisticMessages: r } = t(), l = r[n] ?? [];
        e({
          optimisticMessages: {
            ...r,
            [n]: [...l, a]
          }
        });
      },
      confirmMessage: (n, a, r) => {
        const { optimisticMessages: l } = t(), c = l[n] ?? [];
        e({
          optimisticMessages: {
            ...l,
            [n]: c.filter((m) => m._tempID !== a)
          }
        });
      },
      markOptimisticFailed: (n, a) => {
        const { optimisticMessages: r } = t(), l = r[n] ?? [];
        e({
          optimisticMessages: {
            ...r,
            [n]: l.map(
              (c) => c._tempID === a ? { ...c, _sendStatus: "failed" } : c
            )
          }
        });
      },
      clearOptimistic: (n) => {
        const { optimisticMessages: a } = t();
        e({
          optimisticMessages: { ...a, [n]: [] }
        });
      }
    }),
    {
      name: on,
      storage: Ot(() => localStorage),
      partialize: (e) => ({
        lastOpenRoomID: e.lastOpenRoomID
      })
    }
  )
), cn = "_list_wahdi_1", ln = "_searchBar_wahdi_8", dn = "_items_wahdi_13", un = "_item_wahdi_13", mn = "_itemActive_wahdi_35", pn = "_avatar_wahdi_42", hn = "_content_wahdi_56", fn = "_name_wahdi_64", yn = "_time_wahdi_68", gn = "_preview_wahdi_73", _n = "_loadMore_wahdi_78", B = {
  list: cn,
  searchBar: ln,
  items: dn,
  item: un,
  itemActive: mn,
  avatar: pn,
  content: hn,
  name: fn,
  time: yn,
  preview: gn,
  loadMore: _n
};
k.extend(Lt);
function bn({
  conversations: e,
  isLoading: t,
  activeRoomID: n,
  onSelectRoom: a,
  hasNextPage: r = !1,
  isFetchingNextPage: l = !1,
  onLoadMore: c,
  searchValue: m = "",
  onSearchChange: y,
  isSearching: p = !1
}) {
  const S = P(
    (_) => {
      if (!r || l || !c)
        return;
      const O = _.currentTarget;
      O.scrollHeight - O.scrollTop - O.clientHeight < 80 && c();
    },
    [r, l, c]
  );
  return t ? /* @__PURE__ */ s(w, { align: "center", justify: "center", style: { flex: 1 }, children: /* @__PURE__ */ s(ve, {}) }) : /* @__PURE__ */ d("div", { className: B.list, children: [
    /* @__PURE__ */ s("div", { className: B.searchBar, children: /* @__PURE__ */ s(
      Ye,
      {
        placeholder: "Search conversations…",
        value: m,
        onChange: (_) => {
          y == null || y(_.target.value);
        },
        allowClear: !0,
        size: "small"
      }
    ) }),
    /* @__PURE__ */ s("div", { className: B.items, onScroll: S, children: e.length === 0 ? /* @__PURE__ */ s(
      w,
      {
        align: "center",
        justify: "center",
        style: { padding: 24 },
        children: /* @__PURE__ */ s(v.Text, { type: "secondary", children: p ? "No matching conversations" : "No conversations yet" })
      }
    ) : /* @__PURE__ */ d(We, { children: [
      e.map((_) => /* @__PURE__ */ s(
        vn,
        {
          conversation: _,
          isActive: n === String(_.id),
          onClick: () => {
            a(String(_.id));
          }
        },
        _.id
      )),
      l && /* @__PURE__ */ s(w, { justify: "center", className: B.loadMore, children: /* @__PURE__ */ s(ve, { size: "small" }) })
    ] }) })
  ] });
}
function vn({
  conversation: e,
  isActive: t,
  onClick: n
}) {
  var c, m;
  const [a] = e.participants, r = a && `${(a.lastname ?? "").slice(0, 1)}${(a.firstname ?? "").slice(0, 1)}`.toUpperCase(), l = (c = e.last_message) != null && c.timestamp ? k(e.last_message.timestamp).fromNow() : k(e.updated_on).fromNow();
  return /* @__PURE__ */ d(
    "div",
    {
      className: `${B.item} ${t ? B.itemActive : ""}`,
      onClick: n,
      role: "button",
      tabIndex: 0,
      onKeyDown: (y) => {
        y.key === "Enter" && n();
      },
      children: [
        /* @__PURE__ */ s("div", { className: B.avatar, children: r || "?" }),
        /* @__PURE__ */ d("div", { className: B.content, children: [
          /* @__PURE__ */ d(w, { justify: "space-between", align: "center", children: [
            /* @__PURE__ */ s(v.Text, { strong: !0, ellipsis: !0, className: B.name, children: e.name || "Unnamed" }),
            /* @__PURE__ */ s(v.Text, { type: "secondary", className: B.time, children: l })
          ] }),
          /* @__PURE__ */ d(w, { justify: "space-between", align: "center", children: [
            /* @__PURE__ */ s(
              v.Text,
              {
                type: "secondary",
                ellipsis: !0,
                className: B.preview,
                children: ((m = e.last_message) == null ? void 0 : m.body) ?? "No messages yet"
              }
            ),
            e.unread_count > 0 && /* @__PURE__ */ s(St, { count: e.unread_count, size: "small" })
          ] })
        ] })
      ]
    }
  );
}
const Qe = [];
function wn(e, t = 50) {
  const n = $((c) => c.loggedIn), a = Ce(
    (c) => e ? c.optimisticMessages[e] ?? Qe : Qe
  ), r = Je({
    queryKey: ["chat", "rooms", e, "messages"],
    queryFn: ({ pageParam: c }) => zt(e, {
      before: c,
      limit: t
    }),
    initialPageParam: void 0,
    getNextPageParam: (c) => {
      if (!(!c.has_more || !c.next_token))
        return c.next_token;
    },
    enabled: !!e && n,
    refetchInterval: e && n ? 5e3 : !1
  });
  return {
    messages: Q(() => {
      var y;
      const c = ((y = r.data) == null ? void 0 : y.pages.flatMap((p) => p.messages)) ?? [];
      return [...[...a].reverse(), ...c];
    }, [r.data, a]),
    isLoading: r.isLoading,
    isFetchingNextPage: r.isFetchingNextPage,
    hasNextPage: r.hasNextPage ?? !1,
    fetchNextPage: r.fetchNextPage
  };
}
function Sn(e) {
  const t = $((n) => n.loggedIn);
  return Re({
    queryKey: ["chat", "rooms", e, "pins"],
    queryFn: () => Xt(e),
    enabled: !!e && t,
    staleTime: 5e3,
    refetchInterval: e && t ? 1e4 : !1
  });
}
function Nn(e) {
  const t = Fe(), n = Ie({
    mutationFn: (r) => Zt(e, r),
    onSuccess: async () => {
      await t.invalidateQueries({
        queryKey: ["chat", "rooms", e, "pins"]
      });
    }
  }), a = Ie({
    mutationFn: (r) => en(e, r),
    onSuccess: async () => {
      await t.invalidateQueries({
        queryKey: ["chat", "rooms", e, "pins"]
      });
    }
  });
  return {
    pin: n.mutate,
    unpin: a.mutate,
    isPinning: n.isPending || a.isPending
  };
}
function Tn(e) {
  var c;
  const t = $((m) => m.loggedIn), n = E(null), a = E(!1), r = Re({
    queryKey: ["chat", "rooms", e, "typing"],
    queryFn: () => Jt(e),
    enabled: !!e && t,
    refetchInterval: e && t ? 3e3 : !1,
    staleTime: 1e3
  });
  ne(
    () => () => {
      n.current && clearTimeout(n.current), e && a.current && (Me(e, !1), a.current = !1);
    },
    [e]
  );
  const l = (m) => {
    if (e) {
      if (n.current && clearTimeout(n.current), !m) {
        a.current && (Me(e, !1), a.current = !1);
        return;
      }
      n.current = setTimeout(() => {
        a.current || (Me(e, !0), a.current = !0);
      }, 300);
    }
  };
  return {
    typingUsers: ((c = r.data) == null ? void 0 : c.users) ?? [],
    notifyTyping: l
  };
}
function D(e) {
  const t = (e.lastname ?? "").trim(), n = (e.firstname ?? "").trim();
  return t && n ? `${t}, ${n}` : t || n || String(e.username ?? e.id ?? "");
}
const Cn = /@(\d+)/g;
function Rn(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const a of e)
    n.set(a.id, D(a));
  for (const a of [])
    n.has(a.id) || n.set(a.id, D(a));
  return n;
}
function we(e, t) {
  return e.replace(Cn, (n, a) => {
    const r = Number(a);
    if (!Number.isFinite(r))
      return n;
    const l = t.get(r);
    return l ? `@${l}` : n;
  });
}
const Fn = "_attachment_1c9ay_1", Pn = "_attachmentImage_1c9ay_7", En = "_attachmentFile_1c9ay_14", Ae = {
  attachment: Fn,
  attachmentImage: Pn,
  attachmentFile: En
};
function On({ attachment: e }) {
  var l;
  const [t, n] = R(null);
  ne(() => {
    let c = !1;
    const m = ze();
    return fetch(e.download_url, {
      headers: m ? { Authorization: `Bearer ${m}` } : {}
    }).then((y) => {
      if (!y.ok) throw new Error(`Download failed (${y.status})`);
      return y.blob();
    }).then((y) => {
      c || n(URL.createObjectURL(y));
    }).catch(() => {
    }), () => {
      c = !0, n((y) => (y && URL.revokeObjectURL(y), null));
    };
  }, [e.download_url]);
  const a = (l = e.file_type) == null ? void 0 : l.startsWith("image/"), r = t ?? e.download_url;
  return /* @__PURE__ */ s(
    "a",
    {
      href: r,
      target: "_blank",
      rel: "noopener noreferrer",
      className: Ae.attachment,
      download: t ? e.file_name : void 0,
      children: a && t ? /* @__PURE__ */ s(
        "img",
        {
          src: t,
          alt: e.file_name,
          className: Ae.attachmentImage,
          loading: "lazy"
        }
      ) : /* @__PURE__ */ s(v.Text, { className: Ae.attachmentFile, children: e.file_name })
    }
  );
}
function Ln(e, t, n) {
  e.setQueryData(
    ["chat", "rooms", t, "messages"],
    (a) => {
      var c;
      if (!((c = a == null ? void 0 : a.pages) != null && c.length))
        return {
          pageParams: [void 0],
          pages: [{ messages: [n], has_more: !1 }]
        };
      const [r, ...l] = a.pages;
      return r.messages.some((m) => m.event_id === n.event_id) ? a : {
        ...a,
        pages: [
          { ...r, messages: [n, ...r.messages] },
          ...l
        ]
      };
    }
  );
}
function Mn(e) {
  const t = Fe(), n = $((p) => p.profile), a = Pe(), { addOptimisticMessage: r, confirmMessage: l, markOptimisticFailed: c } = Ce(), m = Ie({
    mutationFn: (p) => Gt(e, p),
    onMutate: (p) => {
      if (!e)
        return;
      const S = `temp_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      return r(e, {
        event_id: S,
        _tempID: S,
        room_id: e,
        sender: {
          id: a ?? (n == null ? void 0 : n.id) ?? 0,
          firstname: (n == null ? void 0 : n.firstname) ?? "",
          lastname: (n == null ? void 0 : n.lastname) ?? ""
        },
        body: p.body,
        reply_to_event_id: p.reply_to_event_id,
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        _sendStatus: "sending"
      }), { tempID: S };
    },
    onSuccess: (p, S, _) => {
      !e || !(_ != null && _.tempID) || (Ln(t, e, p), l(e, _.tempID, p.event_id), t.invalidateQueries({
        queryKey: ["chat", "rooms", e, "detail"]
      }), t.invalidateQueries({
        queryKey: ["chat", "rooms"]
      }));
    },
    onError: (p, S, _) => {
      !e || !(_ != null && _.tempID) || c(e, _.tempID);
    }
  });
  return {
    send: P(
      (p) => {
        e && m.mutate(p);
      },
      [e, m, a, n]
    ),
    isSending: m.isPending
  };
}
const An = "_composer_c9p6d_1", xn = "_fileInput_c9p6d_7", In = "_pendingFiles_c9p6d_11", Dn = "_replyPreview_c9p6d_17", kn = "_replyPreviewContent_c9p6d_28", $n = "_replyPreviewLabel_c9p6d_33", Un = "_replyPreviewBody_c9p6d_39", Bn = "_inputRow_c9p6d_45", Hn = "_input_c9p6d_45", qn = "_sendBtn_c9p6d_60", V = {
  composer: An,
  fileInput: xn,
  pendingFiles: In,
  replyPreview: Dn,
  replyPreviewContent: kn,
  replyPreviewLabel: $n,
  replyPreviewBody: Un,
  inputRow: Bn,
  input: Hn,
  sendBtn: qn
};
function Kn() {
  const e = document.querySelector(".ant-mentions-dropdown");
  if (!e)
    return !1;
  const t = window.getComputedStyle(e);
  return t.display !== "none" && t.visibility !== "hidden";
}
function Vn({
  roomID: e,
  replyTo: t = null,
  onClearReply: n,
  mentionLabels: a,
  onTypingChange: r
}) {
  const [l, c] = R(""), [m, y] = R([]), { send: p, isSending: S } = Mn(e), _ = Pe(), { data: O } = et(e), N = E(null), b = E(null), C = Q(() => (O ?? []).filter((h) => h.id !== _).map((h) => ({
    value: String(h.id),
    label: D(h)
  })), [O, _]), H = P(async () => {
    var L;
    const h = l.trim();
    if (!h && m.length === 0)
      return;
    let g = [];
    if (m.length > 0)
      try {
        g = await Promise.all(
          m.map((M) => nn(M))
        );
      } catch {
        te.error("File upload failed.");
        return;
      }
    const F = h || (m.length > 0 ? "(attachment)" : "");
    p({
      body: F,
      attachment_ids: g.length > 0 ? g : void 0,
      reply_to_event_id: t && !t._tempID ? t.event_id : void 0
    }), c(""), y([]), n == null || n(), r == null || r(!1), (L = N.current) == null || L.focus();
  }, [l, m, p, t, n, r]), U = P(
    (h) => {
      h.key === "Enter" && !h.shiftKey && !Kn() && (h.preventDefault(), H());
    },
    [H]
  ), se = P(
    (h) => {
      c(h), r == null || r(h.trim().length > 0);
    },
    [r]
  ), j = t && a ? we(t.body, a) : t == null ? void 0 : t.body;
  return /* @__PURE__ */ d("div", { className: V.composer, children: [
    /* @__PURE__ */ s(
      "input",
      {
        ref: b,
        type: "file",
        multiple: !0,
        className: V.fileInput,
        onChange: (h) => {
          const g = h.target.files;
          g != null && g.length && (y((F) => [...F, ...Array.from(g)]), h.target.value = "");
        }
      }
    ),
    t ? /* @__PURE__ */ d("div", { className: V.replyPreview, children: [
      /* @__PURE__ */ d("div", { className: V.replyPreviewContent, children: [
        /* @__PURE__ */ d(
          v.Text,
          {
            type: "secondary",
            className: V.replyPreviewLabel,
            children: [
              "Replying to ",
              D(t.sender)
            ]
          }
        ),
        /* @__PURE__ */ s(
          v.Text,
          {
            type: "secondary",
            ellipsis: !0,
            className: V.replyPreviewBody,
            children: j
          }
        )
      ] }),
      /* @__PURE__ */ s(
        I,
        {
          type: "text",
          size: "small",
          icon: /* @__PURE__ */ s(Xe, {}),
          onClick: n,
          "aria-label": "Cancel reply"
        }
      )
    ] }) : null,
    m.length > 0 && /* @__PURE__ */ s(
      v.Text,
      {
        type: "secondary",
        className: V.pendingFiles,
        children: m.map((h) => h.name).join(", ")
      }
    ),
    /* @__PURE__ */ d(w, { gap: 8, align: "end", className: V.inputRow, children: [
      /* @__PURE__ */ s(
        I,
        {
          type: "text",
          icon: /* @__PURE__ */ s(Mt, {}),
          onClick: () => {
            var h;
            return (h = b.current) == null ? void 0 : h.click();
          },
          "aria-label": "Attach file"
        }
      ),
      /* @__PURE__ */ s(
        Nt,
        {
          ref: N,
          value: l,
          onChange: se,
          onKeyDown: U,
          options: C,
          filterOption: (h, g) => {
            const F = String((g == null ? void 0 : g.label) ?? ""), L = String((g == null ? void 0 : g.value) ?? ""), M = h.toLowerCase();
            return F.toLowerCase().includes(M) || L.includes(M);
          },
          prefix: "@",
          split: " ",
          placeholder: "Message… Type @ to mention someone",
          autoSize: { minRows: 1, maxRows: 4 },
          className: V.input,
          notFoundContent: "No matching members"
        }
      ),
      /* @__PURE__ */ s(
        I,
        {
          type: "primary",
          icon: /* @__PURE__ */ s(At, {}),
          onClick: () => void H(),
          disabled: !l.trim() && m.length === 0 || S,
          loading: S,
          className: V.sendBtn
        }
      )
    ] })
  ] });
}
const Qn = "_sidebar_x52bx_1", jn = "_header_x52bx_10", Gn = "_content_x52bx_15", zn = "_sectionTitle_x52bx_21", Wn = "_memberList_x52bx_27", Jn = "_memberItem_x52bx_31", Yn = "_avatar_x52bx_35", Xn = "_memberName_x52bx_39", Zn = "_memberRole_x52bx_44", W = {
  sidebar: Qn,
  header: jn,
  content: Gn,
  sectionTitle: zn,
  memberList: Wn,
  memberItem: Jn,
  avatar: Yn,
  memberName: Xn,
  memberRole: Zn
};
function es({ roomID: e }) {
  const { data: t, isLoading: n } = et(e);
  return /* @__PURE__ */ d(w, { vertical: !0, className: W.sidebar, children: [
    /* @__PURE__ */ s("div", { className: W.header, children: /* @__PURE__ */ s(v.Title, { level: 5, style: { margin: 0 }, children: "Room Details" }) }),
    /* @__PURE__ */ d("div", { className: W.content, children: [
      /* @__PURE__ */ d(v.Text, { strong: !0, className: W.sectionTitle, children: [
        "Members (",
        (t == null ? void 0 : t.length) ?? 0,
        ")"
      ] }),
      n ? /* @__PURE__ */ s(w, { justify: "center", style: { padding: 24 }, children: /* @__PURE__ */ s(ve, { size: "small" }) }) : /* @__PURE__ */ s(w, { vertical: !0, gap: 12, className: W.memberList, children: t == null ? void 0 : t.map((a) => /* @__PURE__ */ d(w, { align: "center", gap: 12, className: W.memberItem, children: [
        /* @__PURE__ */ s(Tt, { icon: /* @__PURE__ */ s(xt, {}), className: W.avatar }),
        /* @__PURE__ */ d(w, { vertical: !0, children: [
          /* @__PURE__ */ s(v.Text, { strong: !0, className: W.memberName, children: D(a) }),
          /* @__PURE__ */ s(v.Text, { type: "secondary", className: W.memberRole, children: a.role })
        ] })
      ] }, a.id)) })
    ] })
  ] });
}
const ts = "_roomView_1occa_2", ns = "_header_1occa_8", ss = "_pinnedStrip_1occa_14", as = "_pinnedStripLeft_1occa_20", rs = "_pinsModal_1occa_26", is = "_pinTitleIcon_1occa_32", os = "_pinsEmpty_1occa_37", cs = "_pinsEmptyIcon_1occa_42", ls = "_pinsList_1occa_48", ds = "_pinRow_1occa_54", us = "_pinRowBody_1occa_68", ms = "_pinRowHeader_1occa_74", ps = "_pinRowPreview_1occa_78", hs = "_pinRowUnpin_1occa_85", fs = "_roomTitleClickable_1occa_90", ys = "_infoBtnActive_1occa_101", gs = "_mainArea_1occa_106", _s = "_messagesContainer_1occa_112", bs = "_messages_1occa_112", vs = "_dateSeparator_1occa_130", ws = "_newMessagesDivider_1occa_152", Ss = "_jumpToLatest_1occa_169", Ns = "_backBtn_1occa_178", Ts = "_row_1occa_183", Cs = "_rowOwn_1occa_188", Rs = "_rowOther_1occa_192", Fs = "_bubbleColumn_1occa_196", Ps = "_senderName_1occa_211", Es = "_bubbleWrap_1occa_219", Os = "_bubbleWrapOwn_1occa_227", Ls = "_bubbleWrapOther_1occa_231", Ms = "_moreBtn_1occa_235", As = "_replyQuote_1occa_254", xs = "_replyQuoteClickable_1occa_261", Is = "_rowHighlighted_1occa_270", Ds = "_bubble_1occa_196", ks = "_replyQuoteAuthor_1occa_275", $s = "_replyQuoteBody_1occa_281", Us = "_typingIndicator_1occa_288", Bs = "_bubbleOther_1occa_304", Hs = "_bubbleOwn_1occa_309", qs = "_optimistic_1occa_314", Ks = "_bubbleBody_1occa_318", Vs = "_bubbleMeta_1occa_322", Qs = "_timestamp_1occa_328", js = "_receiptRow_1occa_333", Gs = "_receiptState_1occa_341", zs = "_receiptIcon_1occa_350", Ws = "_doubleCheck_1occa_364", Js = "_receiptGrey_1occa_370", Ys = "_receiptRead_1occa_375", Xs = "_receiptReadIcon_1occa_379", Zs = "_receiptSending_1occa_389", ea = "_receiptFailed_1occa_393", o = {
  roomView: ts,
  header: ns,
  pinnedStrip: ss,
  pinnedStripLeft: as,
  pinsModal: rs,
  pinTitleIcon: is,
  pinsEmpty: os,
  pinsEmptyIcon: cs,
  pinsList: ls,
  pinRow: ds,
  pinRowBody: us,
  pinRowHeader: ms,
  pinRowPreview: ps,
  pinRowUnpin: hs,
  roomTitleClickable: fs,
  infoBtnActive: ys,
  mainArea: gs,
  messagesContainer: _s,
  messages: bs,
  dateSeparator: vs,
  newMessagesDivider: ws,
  jumpToLatest: Ss,
  backBtn: Ns,
  row: Ts,
  rowOwn: Cs,
  rowOther: Rs,
  bubbleColumn: Fs,
  senderName: Ps,
  bubbleWrap: Es,
  bubbleWrapOwn: Os,
  bubbleWrapOther: Ls,
  moreBtn: Ms,
  replyQuote: As,
  replyQuoteClickable: xs,
  rowHighlighted: Is,
  bubble: Ds,
  replyQuoteAuthor: ks,
  replyQuoteBody: $s,
  typingIndicator: Us,
  bubbleOther: Bs,
  bubbleOwn: Hs,
  optimistic: qs,
  bubbleBody: Ks,
  bubbleMeta: Vs,
  timestamp: Qs,
  receiptRow: js,
  receiptState: Gs,
  receiptIcon: zs,
  doubleCheck: Ws,
  receiptGrey: Js,
  receiptRead: Ys,
  receiptReadIcon: Xs,
  receiptSending: Zs,
  receiptFailed: ea
};
function ta(e, t, n) {
  if (!(n != null && n.length))
    return !1;
  const a = n.filter((c) => c.user_id !== t);
  if (a.length === 0)
    return !1;
  const r = new Date(e).getTime();
  if (!Number.isFinite(r))
    return !1;
  const l = 750;
  return a.every((c) => {
    if (!c.last_read_ts)
      return !1;
    const m = new Date(c.last_read_ts).getTime();
    return Number.isFinite(m) && m >= r - l;
  });
}
const xe = 2500, na = 120;
function je(e) {
  return e.scrollHeight - e.scrollTop - e.clientHeight <= na;
}
function sa(e) {
  const t = k(e);
  return t.isSame(k(), "day") ? "Today" : t.isSame(k().subtract(1, "day"), "day") ? "Yesterday" : t.isSame(k(), "year") ? t.format("MMM D") : t.format("MMM D, YYYY");
}
function aa({ roomID: e, onBack: t }) {
  var u;
  const n = Fe(), a = Pe(), [r, l] = R(!1), [c, m] = R(null), [y, p] = R(!1), [S, _] = R(null), [O, N] = R(!1);
  ne(() => {
    m(null);
  }, [e]);
  const { data: b } = rn(e), { typingUsers: C, notifyTyping: H } = Tn(e), { data: U } = Sn(e), { pin: se, unpin: j } = Nn(e), {
    messages: h,
    isLoading: g,
    hasNextPage: F,
    fetchNextPage: L,
    isFetchingNextPage: M
  } = wn(e), G = Q(() => {
    var f;
    if (h.length === 0) return;
    const i = (f = h[0]) == null ? void 0 : f.event_id;
    if (!(!i || i.startsWith("temp_")))
      return i;
  }, [h]), J = E(null), fe = E(null), Y = E(/* @__PURE__ */ new Map()), ae = E(0), ye = E(e), X = E(void 0), q = E(!0), Z = E(null), [me, Se] = R(
    null
  );
  Ge(() => {
    var Ue, Be;
    const i = fe.current, f = h[0], T = f == null ? void 0 : f.event_id;
    ye.current !== e && (ye.current = e, X.current = void 0, ae.current = 0, q.current = !0, Z.current = null, _(null), N(!1));
    const de = Z.current;
    if (i && de && h.length > ae.current)
      i.scrollTop = i.scrollHeight - de.scrollHeight + de.scrollTop, q.current = je(i), Z.current = null;
    else if (i && h.length > 0) {
      const tt = !X.current, He = !!T && T !== X.current, nt = a !== void 0 && (f == null ? void 0 : f.sender.id) === a;
      tt ? ((Ue = J.current) == null || Ue.scrollIntoView({ behavior: "auto" }), q.current = !0, _(null), N(!1)) : He && (q.current || nt) ? ((Be = J.current) == null || Be.scrollIntoView({ behavior: "smooth" }), _(null), N(!1)) : He && T && (_((st) => st ?? T), N(!0));
    }
    ae.current = h.length, X.current = T;
  }, [a, h, e]), ne(() => {
    let i = !1;
    return e && G && (async () => {
      try {
        if (await Yt(e, G), i) return;
        await n.invalidateQueries({
          queryKey: ["chat", "rooms"]
        }), await n.invalidateQueries({
          queryKey: ["chat", "rooms", e, "detail"]
        });
      } catch {
      }
    })(), () => {
      i = !0;
    };
  }, [e, G, n]);
  const re = P(() => {
    const i = fe.current;
    i && (q.current = je(i), q.current && (_(null), N(!1)), !(!F || M || Z.current) && i.scrollTop < 100 && (Z.current = {
      scrollHeight: i.scrollHeight,
      scrollTop: i.scrollTop
    }, L().finally(() => {
      window.setTimeout(() => {
        Z.current = null;
      }, 0);
    })));
  }, [F, M, L]), ge = P(() => {
    var i;
    (i = J.current) == null || i.scrollIntoView({ behavior: "smooth" }), q.current = !0, _(null), N(!1);
  }, []), ee = [...h].reverse(), ie = b == null ? void 0 : b.member_read_status, K = Q(
    () => Rn((b == null ? void 0 : b.participants) ?? []),
    [b == null ? void 0 : b.participants]
  ), pe = Q(() => {
    const i = /* @__PURE__ */ new Map();
    for (const f of h)
      i.set(f.event_id, f);
    return i;
  }, [h]), Ne = Q(() => C.length === 0 ? "" : C.length === 1 ? `${D(C[0])} is typing…` : C.length === 2 ? `${D(C[0])} and ${D(C[1])} are typing…` : `${C.length} people are typing…`, [C]), z = (U == null ? void 0 : U.pins) ?? [], oe = Q(
    () => new Set(z.map((i) => i.event_id)),
    [z]
  ), ce = (u = z[0]) == null ? void 0 : u.message, Ee = `${z.length} pinned`, he = ce != null && ce.body ? we(ce.body, K) : "", _e = P(
    async (i) => {
      for (let f = 0; f < 20; f += 1) {
        const T = Y.current.get(i);
        if (T) {
          T.scrollIntoView({ behavior: "smooth", block: "center" }), Se(i), window.setTimeout(() => {
            Se(null);
          }, 2e3);
          return;
        }
        if (!F || M)
          break;
        await L();
      }
    },
    [L, F, M]
  ), Oe = P(
    (i, f) => {
      if (f) {
        Y.current.set(i, f);
        return;
      }
      Y.current.delete(i);
    },
    []
  );
  return /* @__PURE__ */ d(w, { vertical: !0, className: o.roomView, children: [
    /* @__PURE__ */ s("div", { className: o.header, children: /* @__PURE__ */ d(w, { align: "center", justify: "space-between", children: [
      /* @__PURE__ */ d(w, { align: "center", gap: 12, children: [
        t && /* @__PURE__ */ s(
          I,
          {
            type: "text",
            icon: /* @__PURE__ */ s(It, {}),
            onClick: t,
            className: o.backBtn
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            className: o.roomTitleClickable,
            onClick: () => l(!r),
            role: "button",
            tabIndex: 0,
            onKeyDown: (i) => {
              i.key === "Enter" && l(!r);
            },
            children: [
              /* @__PURE__ */ s(v.Text, { strong: !0, children: (b == null ? void 0 : b.name) || "Chat" }),
              (b == null ? void 0 : b.participants) && /* @__PURE__ */ d(
                v.Text,
                {
                  type: "secondary",
                  style: {
                    display: "block",
                    fontSize: 12
                  },
                  children: [
                    b.participants.length,
                    " participant",
                    b.participants.length !== 1 ? "s" : ""
                  ]
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ s(
        I,
        {
          type: "text",
          icon: /* @__PURE__ */ s(Dt, {}),
          onClick: () => l(!r),
          className: r ? o.infoBtnActive : ""
        }
      )
    ] }) }),
    ce ? /* @__PURE__ */ s("div", { className: o.pinnedStrip, children: /* @__PURE__ */ d(w, { align: "center", justify: "space-between", gap: 12, children: [
      /* @__PURE__ */ d(
        w,
        {
          align: "center",
          gap: 8,
          className: o.pinnedStripLeft,
          onClick: () => p(!0),
          role: "button",
          tabIndex: 0,
          onKeyDown: (i) => {
            i.key === "Enter" && p(!0);
          },
          children: [
            /* @__PURE__ */ s(ke, {}),
            /* @__PURE__ */ s(v.Text, { strong: !0, children: Ee }),
            /* @__PURE__ */ s(v.Text, { type: "secondary", ellipsis: !0, children: he })
          ]
        }
      ),
      /* @__PURE__ */ s(I, { type: "link", onClick: () => p(!0), children: "View all" })
    ] }) }) : null,
    /* @__PURE__ */ d(w, { className: o.mainArea, children: [
      /* @__PURE__ */ d("div", { className: o.messagesContainer, children: [
        /* @__PURE__ */ d(
          "div",
          {
            ref: fe,
            className: o.messages,
            onScroll: re,
            children: [
              M && /* @__PURE__ */ s(w, { justify: "center", style: { padding: 8 }, children: /* @__PURE__ */ s(ve, { size: "small" }) }),
              g ? /* @__PURE__ */ s(w, { align: "center", justify: "center", style: { flex: 1 }, children: /* @__PURE__ */ s(ve, {}) }) : ee.length === 0 ? /* @__PURE__ */ s(w, { align: "center", justify: "center", style: { flex: 1 }, children: /* @__PURE__ */ s(v.Text, { type: "secondary", children: "No messages yet. Say hello!" }) }) : /* @__PURE__ */ s(We, { children: ee.map((i, f) => {
                const T = ee[f - 1], le = !T || !k(T.timestamp).isSame(
                  k(i.timestamp),
                  "day"
                ), de = S === i.event_id;
                return /* @__PURE__ */ d(it, { children: [
                  le && /* @__PURE__ */ s("div", { className: o.dateSeparator, children: /* @__PURE__ */ s("span", { children: sa(
                    i.timestamp
                  ) }) }),
                  de && /* @__PURE__ */ s(
                    "button",
                    {
                      type: "button",
                      className: o.newMessagesDivider,
                      onClick: ge,
                      children: "New messages"
                    }
                  ),
                  /* @__PURE__ */ s(
                    ra,
                    {
                      message: i,
                      currentUserID: a,
                      memberReadStatus: ie,
                      mentionLabels: K,
                      replyToMessage: i.reply_to_event_id ? pe.get(
                        i.reply_to_event_id
                      ) : void 0,
                      onReply: () => m(i),
                      onPin: () => {
                        i.event_id.startsWith("temp_") || (oe.has(i.event_id) ? j(i.event_id) : se(i.event_id));
                      },
                      isPinned: oe.has(i.event_id),
                      onReplyQuoteClick: i.reply_to_event_id ? () => {
                        _e(
                          i.reply_to_event_id
                        );
                      } : void 0,
                      registerRef: Oe,
                      isHighlighted: me === i.event_id
                    }
                  )
                ] }, i.event_id);
              }) }),
              /* @__PURE__ */ s("div", { ref: J })
            ]
          }
        ),
        O ? /* @__PURE__ */ s(
          I,
          {
            type: "primary",
            shape: "round",
            icon: /* @__PURE__ */ s(kt, {}),
            className: o.jumpToLatest,
            onClick: ge,
            children: "Jump to latest"
          }
        ) : null,
        Ne ? /* @__PURE__ */ s("div", { className: o.typingIndicator, children: /* @__PURE__ */ s(v.Text, { type: "secondary", children: Ne }) }) : null,
        /* @__PURE__ */ s(
          Vn,
          {
            roomID: e,
            replyTo: c,
            onClearReply: () => m(null),
            mentionLabels: K,
            onTypingChange: H
          }
        )
      ] }),
      r && /* @__PURE__ */ s(es, { roomID: e })
    ] }),
    /* @__PURE__ */ s(
      De,
      {
        title: /* @__PURE__ */ d(w, { align: "center", justify: "space-between", children: [
          /* @__PURE__ */ d(w, { align: "center", gap: 10, children: [
            /* @__PURE__ */ s($e, { className: o.pinTitleIcon }),
            /* @__PURE__ */ s(v.Text, { strong: !0, children: "Pinned messages" }),
            /* @__PURE__ */ d(v.Text, { type: "secondary", children: [
              "(",
              z.length,
              ")"
            ] })
          ] }),
          /* @__PURE__ */ s(
            I,
            {
              type: "text",
              icon: /* @__PURE__ */ s(Xe, {}),
              onClick: () => p(!1),
              "aria-label": "Close"
            }
          )
        ] }),
        open: y,
        onCancel: () => p(!1),
        closable: !1,
        footer: null,
        width: 720,
        centered: !0,
        className: o.pinsModal,
        destroyOnClose: !0,
        children: z.length === 0 ? /* @__PURE__ */ d(
          w,
          {
            vertical: !0,
            align: "center",
            justify: "center",
            className: o.pinsEmpty,
            children: [
              /* @__PURE__ */ s(ke, { className: o.pinsEmptyIcon }),
              /* @__PURE__ */ s(v.Text, { type: "secondary", children: "No pinned messages" }),
              /* @__PURE__ */ s(v.Text, { type: "secondary", children: "Pin a message to find it quickly later." })
            ]
          }
        ) : /* @__PURE__ */ s("div", { className: o.pinsList, children: z.map((i) => {
          var f, T, le;
          return /* @__PURE__ */ s("div", { className: o.pinRow, children: /* @__PURE__ */ d(w, { justify: "space-between", gap: 12, align: "flex-start", children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: o.pinRowBody,
                role: "button",
                tabIndex: 0,
                onClick: () => {
                  p(!1), _e(i.event_id);
                },
                onKeyDown: (de) => {
                  de.key === "Enter" && (p(!1), _e(i.event_id));
                },
                children: [
                  /* @__PURE__ */ d(
                    w,
                    {
                      align: "center",
                      justify: "space-between",
                      gap: 12,
                      className: o.pinRowHeader,
                      children: [
                        /* @__PURE__ */ s(v.Text, { strong: !0, children: (f = i.message) != null && f.sender ? D(
                          i.message.sender
                        ) : D(i.pinned_by) }),
                        /* @__PURE__ */ s(v.Text, { type: "secondary", children: (T = i.message) != null && T.timestamp ? k(
                          i.message.timestamp
                        ).format("MMM D, h:mm A") : k(i.pinned_on).format(
                          "MMM D, h:mm A"
                        ) })
                      ]
                    }
                  ),
                  /* @__PURE__ */ s("div", { className: o.pinRowPreview, children: /* @__PURE__ */ s(v.Text, { type: "secondary", children: (le = i.message) != null && le.body ? we(
                    i.message.body,
                    K
                  ) : "(message not available)" }) })
                ]
              }
            ),
            /* @__PURE__ */ s(
              I,
              {
                type: "text",
                icon: /* @__PURE__ */ s($e, {}),
                className: o.pinRowUnpin,
                onClick: () => j(i.event_id),
                "aria-label": "Unpin"
              }
            )
          ] }) }, i.event_id);
        }) })
      }
    )
  ] });
}
function ra({
  message: e,
  currentUserID: t,
  memberReadStatus: n,
  mentionLabels: a,
  replyToMessage: r,
  onReply: l,
  onPin: c,
  isPinned: m,
  onReplyQuoteClick: y,
  registerRef: p,
  isHighlighted: S
}) {
  var h;
  const _ = e._sendStatus === "failed", O = e._sendStatus === "sending", N = !!e._tempID, b = t !== void 0 && e.sender.id === t, C = b && !N && t !== void 0 && ta(
    e.timestamp,
    t,
    n
  ), [H, U] = R(() => {
    const g = new Date(e.timestamp).getTime();
    return Number.isFinite(g) && Date.now() - g >= xe;
  });
  ne(() => {
    if (!b || N || C)
      return;
    const g = new Date(e.timestamp).getTime();
    if (!Number.isFinite(g)) {
      U(!0);
      return;
    }
    const F = Date.now() - g;
    if (F >= xe) {
      U(!0);
      return;
    }
    const L = window.setTimeout(() => {
      U(!0);
    }, xe - F);
    return () => {
      window.clearTimeout(L);
    };
  }, [b, N, C, e.timestamp]);
  const se = we(e.body, a), j = r ? we(r.body, a) : void 0;
  return /* @__PURE__ */ s(
    "div",
    {
      ref: (g) => {
        p(e.event_id, g);
      },
      className: `${o.row} ${b ? o.rowOwn : o.rowOther}${S ? ` ${o.rowHighlighted}` : ""}`,
      children: /* @__PURE__ */ d("div", { className: o.bubbleColumn, children: [
        !b && /* @__PURE__ */ s("div", { className: o.senderName, children: D(e.sender) }),
        /* @__PURE__ */ d(
          "div",
          {
            className: `${o.bubbleWrap} ${b ? o.bubbleWrapOwn : o.bubbleWrapOther}`,
            children: [
              /* @__PURE__ */ s(
                Ct,
                {
                  placement: b ? "bottomRight" : "bottomLeft",
                  trigger: ["click"],
                  menu: {
                    items: [
                      {
                        key: "reply",
                        label: "Reply",
                        icon: /* @__PURE__ */ s(Ut, {}),
                        onClick: () => l()
                      },
                      {
                        key: "pin",
                        label: m ? "Unpin" : "Pin",
                        icon: m ? /* @__PURE__ */ s($e, {}) : /* @__PURE__ */ s(ke, {}),
                        onClick: () => c()
                      }
                    ]
                  },
                  children: /* @__PURE__ */ s(
                    I,
                    {
                      type: "text",
                      size: "small",
                      icon: /* @__PURE__ */ s($t, {}),
                      className: o.moreBtn,
                      "aria-label": "Message actions"
                    }
                  )
                }
              ),
              /* @__PURE__ */ d(
                "div",
                {
                  className: `${o.bubble} ${b ? o.bubbleOwn : o.bubbleOther} ${N ? o.optimistic : ""}`,
                  children: [
                    r && j && /* @__PURE__ */ d(
                      "div",
                      {
                        className: `${o.replyQuote}${y ? ` ${o.replyQuoteClickable}` : ""}`,
                        onClick: y ? (g) => {
                          g.stopPropagation(), y();
                        } : void 0,
                        onKeyDown: y ? (g) => {
                          (g.key === "Enter" || g.key === " ") && (g.preventDefault(), y());
                        } : void 0,
                        role: y ? "button" : void 0,
                        tabIndex: y ? 0 : void 0,
                        children: [
                          /* @__PURE__ */ s(
                            v.Text,
                            {
                              strong: !0,
                              className: o.replyQuoteAuthor,
                              children: D(r.sender)
                            }
                          ),
                          /* @__PURE__ */ s(
                            v.Text,
                            {
                              type: "secondary",
                              ellipsis: !0,
                              className: o.replyQuoteBody,
                              children: j
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ s("div", { className: o.bubbleBody, children: /* @__PURE__ */ s(v.Text, { children: se }) }),
                    (h = e.attachments) == null ? void 0 : h.map((g) => /* @__PURE__ */ s(On, { attachment: g }, g.media_id)),
                    /* @__PURE__ */ s("div", { className: o.bubbleMeta, children: /* @__PURE__ */ s(
                      v.Text,
                      {
                        type: "secondary",
                        className: o.timestamp,
                        children: k(e.timestamp).format("h:mm A")
                      }
                    ) })
                  ]
                }
              )
            ]
          }
        ),
        b && /* @__PURE__ */ s("div", { className: o.receiptRow, children: _ ? /* @__PURE__ */ d(
          "span",
          {
            className: `${o.receiptState} ${o.receiptFailed}`,
            "aria-label": "Failed",
            children: [
              /* @__PURE__ */ s(Bt, { className: o.receiptIcon }),
              /* @__PURE__ */ s("span", { children: "Failed" })
            ]
          }
        ) : O || N ? /* @__PURE__ */ d(
          "span",
          {
            className: `${o.receiptState} ${o.receiptSending}`,
            "aria-label": "Sending",
            children: [
              /* @__PURE__ */ s(Ht, { spin: !0, className: o.receiptIcon }),
              /* @__PURE__ */ s("span", { children: "Sending" })
            ]
          }
        ) : C ? /* @__PURE__ */ d(
          "span",
          {
            className: `${o.receiptState} ${o.receiptRead}`,
            "aria-label": "Read",
            children: [
              /* @__PURE__ */ d("span", { className: o.doubleCheck, children: [
                /* @__PURE__ */ s(
                  be,
                  {
                    className: `${o.receiptIcon} ${o.receiptReadIcon}`
                  }
                ),
                /* @__PURE__ */ s(
                  be,
                  {
                    className: `${o.receiptIcon} ${o.receiptReadIcon}`
                  }
                )
              ] }),
              /* @__PURE__ */ s("span", { children: "Read" })
            ]
          }
        ) : H ? /* @__PURE__ */ d(
          "span",
          {
            className: o.receiptState,
            "aria-label": "Delivered",
            children: [
              /* @__PURE__ */ d("span", { className: o.doubleCheck, children: [
                /* @__PURE__ */ s(
                  be,
                  {
                    className: `${o.receiptIcon} ${o.receiptGrey}`
                  }
                ),
                /* @__PURE__ */ s(
                  be,
                  {
                    className: `${o.receiptIcon} ${o.receiptGrey}`
                  }
                )
              ] }),
              /* @__PURE__ */ s("span", { children: "Delivered" })
            ]
          }
        ) : /* @__PURE__ */ d(
          "span",
          {
            className: o.receiptState,
            "aria-label": "Sent",
            children: [
              /* @__PURE__ */ s(
                be,
                {
                  className: `${o.receiptIcon} ${o.receiptGrey}`
                }
              ),
              /* @__PURE__ */ s("span", { children: "Sent" })
            ]
          }
        ) })
      ] })
    }
  );
}
const ia = "_chatPanel_1fmzn_1", oa = "_sidebar_1fmzn_9", ca = "_sidebarHeader_1fmzn_18", la = "_main_1fmzn_30", da = "_emptyState_1fmzn_37", ua = "_sidebarHidden_1fmzn_47", ma = "_mainHidden_1fmzn_53", ue = {
  chatPanel: ia,
  sidebar: oa,
  sidebarHeader: ca,
  main: la,
  emptyState: da,
  sidebarHidden: ua,
  mainHidden: ma
};
function xa() {
  const e = Fe(), t = bt(), n = vt({ strict: !1 }), a = wt({ select: (u) => u.location.pathname }), r = Ce((u) => u.lastOpenRoomID), l = Ce((u) => u.setLastOpenRoomID), c = $((u) => u.profile), { canPath: m } = qt(), y = m(Vt), p = Pe(), S = n.roomID !== void 0 && n.roomID !== "" ? String(n.roomID) : null, [_, O] = R(""), [N, b] = R(""), C = E(
    null
  );
  ne(() => (C.current && clearTimeout(C.current), C.current = setTimeout(() => {
    b(_.trim());
  }, 300), () => {
    C.current && clearTimeout(C.current);
  }), [_]);
  const H = N.length >= 3 ? N : void 0, {
    conversations: U,
    isLoading: se,
    hasNextPage: j,
    isFetchingNextPage: h,
    fetchNextPage: g
  } = an({ q: H }), F = E(null), [L, M] = R(
    null
  ), [G, J] = R(null), [fe, Y] = R(""), [ae, ye] = R(""), [X, q] = R([]), [Z, me] = R([]), [Se, re] = R([]), [ge, ee] = R(!1), ie = E(null), K = E(
    null
  ), pe = P(() => {
    M(null), J(null), Y(""), ye(""), q([]), me([]), re([]);
  }, []);
  ne(
    () => () => {
      ie.current && clearTimeout(ie.current), K.current && clearTimeout(K.current), C.current && clearTimeout(C.current);
    },
    []
  ), Ge(() => {
    if (!a.startsWith("/chat")) {
      F.current = null;
      return;
    }
    const u = F.current;
    if (S) {
      l(S), F.current = a;
      return;
    }
    a === "/chat" && r && (u !== null && u.startsWith("/chat/") && u !== "/chat" || t({
      replace: !0,
      to: "/chat/$roomID",
      params: { roomID: r }
    })), F.current = a;
  }, [a, S, r, t, l]);
  const Ne = P(
    (u) => {
      t({
        to: "/chat/$roomID",
        params: { roomID: u }
      });
    },
    [t]
  ), z = P(() => {
    t({ to: "/chat" });
  }, [t]), oe = P(async (u) => {
    if (u.trim().length < 2)
      return re([]), [];
    try {
      const f = (await tn(u)).map((T) => ({
        value: String(T.id),
        label: T.label
      }));
      return re(f), f;
    } catch {
      return re([]), [];
    }
  }, []), ce = P(
    (u) => {
      Y(u), ie.current && clearTimeout(ie.current), ie.current = setTimeout(() => {
        oe(u);
      }, 300);
    },
    [oe]
  ), Ee = P(
    (u) => {
      if (K.current && clearTimeout(K.current), !u.trim()) {
        me([]);
        return;
      }
      K.current = setTimeout(() => {
        oe(u).then((i) => {
          me(
            i.map((f) => ({
              value: Number(f.value),
              label: f.label
            }))
          );
        });
      }, 300);
    },
    [oe]
  ), he = P(
    async (u) => {
      await e.invalidateQueries({
        queryKey: ["chat", "rooms"]
      }), pe(), t({
        to: "/chat/$roomID",
        params: { roomID: String(u) }
      });
    },
    [e, t, pe]
  ), _e = P(async () => {
    const u = p ?? (c == null ? void 0 : c.id);
    if (G === null || G <= 0) {
      te.warning("Search and select a user to message.");
      return;
    }
    if (u !== void 0 && G === u) {
      te.warning("Choose a user other than yourself.");
      return;
    }
    ee(!0);
    try {
      const i = await Ke({
        type: "direct",
        participant_ids: [G]
      });
      await he(i.id), te.success("Conversation opened.");
    } catch {
      te.error(
        "Could not start chat. Check permissions and try again."
      );
    } finally {
      ee(!1);
    }
  }, [G, p, c == null ? void 0 : c.id, he]), Oe = P(async () => {
    const u = p ?? (c == null ? void 0 : c.id), i = X.filter(
      (f) => f > 0 && f !== u
    );
    if (i.length === 0) {
      te.warning("Add at least one other member.");
      return;
    }
    ee(!0);
    try {
      const f = await Ke({
        type: "group",
        name: ae.trim() || void 0,
        participant_ids: i
      });
      await he(f.id), te.success("Group conversation created.");
    } catch {
      te.error(
        "Could not create group. Check permissions and try again."
      );
    } finally {
      ee(!1);
    }
  }, [
    X,
    ae,
    p,
    c == null ? void 0 : c.id,
    he
  ]);
  return /* @__PURE__ */ d(w, { className: ue.chatPanel, children: [
    /* @__PURE__ */ d(
      w,
      {
        className: `${ue.sidebar} ${S ? ue.sidebarHidden : ""}`,
        children: [
          /* @__PURE__ */ d(w, { className: ue.sidebarHeader, children: [
            /* @__PURE__ */ s(v.Title, { level: 4, style: { margin: 0 }, children: "Messages" }),
            y ? /* @__PURE__ */ d(w, { align: "center", gap: 8, children: [
              /* @__PURE__ */ s(
                I,
                {
                  size: "small",
                  onClick: () => {
                    M("direct");
                  },
                  children: "Direct"
                }
              ),
              /* @__PURE__ */ s(
                I,
                {
                  type: "primary",
                  size: "small",
                  onClick: () => {
                    M("group");
                  },
                  children: "Group"
                }
              )
            ] }) : null
          ] }),
          /* @__PURE__ */ s(
            bn,
            {
              conversations: U,
              isLoading: se,
              activeRoomID: S,
              onSelectRoom: Ne,
              hasNextPage: j,
              isFetchingNextPage: h,
              onLoadMore: () => {
                g();
              },
              searchValue: _,
              onSearchChange: O,
              isSearching: H !== void 0
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ s(
      w,
      {
        className: `${ue.main} ${S ? "" : ue.mainHidden}`,
        children: S ? /* @__PURE__ */ s(aa, { roomID: S, onBack: z }) : /* @__PURE__ */ s(
          w,
          {
            align: "center",
            justify: "center",
            className: ue.emptyState,
            children: /* @__PURE__ */ s(v.Text, { type: "secondary", children: y ? "Select a conversation or start a new chat" : "Select a conversation" })
          }
        )
      }
    ),
    /* @__PURE__ */ d(
      De,
      {
        title: "Start direct chat",
        open: L === "direct",
        onCancel: pe,
        onOk: () => {
          _e();
        },
        okText: "Start",
        confirmLoading: ge,
        destroyOnHidden: !0,
        children: [
          /* @__PURE__ */ s(v.Paragraph, { type: "secondary", children: "Type at least 2 letters of a last name or first name, then select a user. Both accounts need chat access (e.g. RCC or patient roles)." }),
          /* @__PURE__ */ s(
            Rt,
            {
              style: { width: "100%" },
              options: Se,
              value: fe,
              onSelect: (u, i) => {
                const f = Number(u);
                Number.isFinite(f) && J(f);
                const T = typeof (i == null ? void 0 : i.label) == "string" ? i.label : typeof (i == null ? void 0 : i.value) == "string" ? i.value : u;
                Y(T);
              },
              onChange: (u) => {
                const i = u;
                if (Y(i), !i.trim()) {
                  J(null), re([]);
                  return;
                }
                ce(i);
              },
              placeholder: "Search by name…",
              allowClear: !0
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ s(
      De,
      {
        title: "Create group chat",
        open: L === "group",
        onCancel: pe,
        onOk: () => {
          Oe();
        },
        okText: "Create",
        confirmLoading: ge,
        destroyOnHidden: !0,
        children: /* @__PURE__ */ d(w, { vertical: !0, gap: 12, children: [
          /* @__PURE__ */ s(
            v.Paragraph,
            {
              type: "secondary",
              style: { margin: 0 },
              children: "Add a name and search for members (at least 2 letters)."
            }
          ),
          /* @__PURE__ */ s(
            Ye,
            {
              placeholder: "Group name (optional)",
              value: ae,
              onChange: (u) => {
                ye(u.target.value);
              },
              allowClear: !0
            }
          ),
          /* @__PURE__ */ s(
            Ft,
            {
              mode: "multiple",
              showSearch: {
                filterOption: !1,
                onSearch: Ee
              },
              style: { width: "100%" },
              placeholder: "Search and select members…",
              value: X,
              options: Z,
              onSelect: (u, i) => {
                const f = typeof (i == null ? void 0 : i.label) == "string" ? i.label : String(u);
                me((T) => T.some((le) => le.value === u) ? T : [...T, { value: u, label: f }]);
              },
              onChange: (u) => {
                q(u);
              },
              notFoundContent: "Type at least 2 letters to search"
            }
          )
        ] })
      }
    )
  ] });
}
export {
  Eo as API_STORE,
  ka as AuthGuardProvider,
  $a as AuthWrapper,
  Ya as BASE_COLUMNS,
  Xa as COLUMN_TYPE_TO_COMPONENT,
  xa as ChatPanel,
  Ua as ClaraAppRender,
  Vn as Composer,
  bn as ConversationList,
  Oo as DB_NAME,
  oc as DataGrid,
  Ui as EMPTY_TABLE_SORTING,
  fo as EntityInlineCrudPanel,
  Ba as FetchProvider,
  yo as FilterPanel,
  go as FlexTabs,
  Ha as FontVariablesOverride,
  lr as FormDraw,
  dr as FormView,
  _o as InfiniteScrollListPage,
  bo as InfiniteScrollListPageLayout,
  Lo as KV_STORE,
  Xo as LOADING_STATUS_KEY,
  vo as LinkProvider,
  ur as LinkProviderContext,
  nc as ListPageLayout,
  qa as LoadingStatusProvider,
  qe as NEU_CLIENT_CHANGE_EVENT,
  yt as NEU_CLIENT_PBM_PORTAL,
  zi as NEU_CLIENT_STORAGE_KEY,
  _t as NEU_CLIENT_WEB,
  Ka as NeuAppRender,
  Va as NeuSharedProvider,
  Ic as PopupForm,
  wo as QueryListPage,
  aa as RoomView,
  Qa as RootLayout,
  Mo as STORES,
  So as SubEntityLayout,
  sc as TabListView,
  cc as Table,
  ac as TableView,
  No as TabsLayout,
  ja as TopBar,
  Ga as UIProvider,
  ft as applyAuthSessionBootstrap,
  Za as applyFieldPostProcessing,
  Wi as buildApiUrl,
  mr as buildCsvContent,
  pr as buildDefaultCsvFilename,
  Ji as buildEntityListQueryString,
  vi as buildFormDraftKey,
  lc as buildTableColumnDefsFromLegacyColumns,
  dc as calcAge,
  hr as canCreateEntityForm,
  fr as canCreateEntityFromUserStore,
  yr as canDeleteEntityForm,
  gr as canDeleteEntityFromUserStore,
  dt as canMutateEntityForm,
  _r as canMutateEntityFromUserStore,
  br as canReadEntityField,
  lt as canReadEntityForm,
  vr as canReadEntityFromUserStore,
  wr as canReadFieldFromUserStore,
  Sr as canSaveEntityForm,
  Nr as canSaveEntityFromUserStore,
  kc as cascadeOptions,
  Tr as clearCustomFieldsForTests,
  Ao as clearDB,
  Cr as clearEntityFormConfigsForTests,
  wi as clearFormDraftsForRecord,
  Rr as clearFormValidatorsForTests,
  xo as clearKV,
  Yi as clearNeuClient,
  Fr as clearRegisteredFieldHandlersForTests,
  Pr as confirmTwoFAEnrollment,
  er as convertOptionsToEnum,
  $c as copyRelatedFields,
  za as createAppRouter,
  Xi as createEntity,
  Zi as createQueryClient,
  La as decryptString,
  uc as defaultSortToTokens,
  mc as defaultTableRowIDResolver,
  Io as deleteEntry,
  Si as deleteFormDraft,
  Do as deleteIf,
  ko as deleteKV,
  Er as downloadCsvFile,
  Ma as encryptString,
  Wa as enforceUiRouteOrRedirect,
  Or as enrollTwoFAMethod,
  Uc as ensureUnique,
  Lr as entityHasColumnOperation,
  pc as extractHTTPStatus,
  A as fetchAPI,
  Mr as fetchAllEntityListRows,
  eo as fetchApi,
  to as fetchDefaultOptional,
  no as fetchDefaultRequired,
  so as fetchEntity,
  ao as fetchEntityList,
  Ar as fieldHasColumnOperation,
  hc as fmt,
  fc as fmtDate,
  yc as fmtDateTime,
  gc as fmtTime,
  _c as formatRelationValue,
  bc as formatUserFacingError,
  $o as gcDB,
  ze as getAuthToken,
  tr as getComponentForColumnType,
  Ni as getDefaultRecordViewMode,
  vc as getDefaultSortTokensFromEntityDef,
  ro as getEntity,
  xr as getEntityFormConfig,
  To as getEntityLabel,
  Ti as getEntityOpenMode,
  Uo as getEntry,
  io as getEntryPointNeuClient,
  nr as getFieldConfigForColumn,
  Ir as getFieldHandler,
  Dr as getFieldPattern,
  kr as getFieldPatternFromUserStore,
  Ci as getFormDraft,
  Bo as getKV,
  gt as getNeuClient,
  wc as getNextSortingState,
  $r as getRegisteredCustomFieldMap,
  Ur as getSessionRoleSlug,
  Br as getSessionUserID,
  Sc as getSortableColumnKeysFromEntityDef,
  ot as getToken,
  Hr as getTwoFAMethods,
  Ho as getValue,
  qr as hasElementAccessFromUserStore,
  ut as hasElementRuleAccess,
  mt as hasPathAccess,
  Kr as hasPathAccessFromUserStore,
  sr as hasSelectableOptions,
  pt as hasUiRouteAccess,
  Vr as hasUiRouteAccessFromUserStore,
  qo as iDB,
  Nc as initials,
  Tc as interpolateTemplate,
  Cc as isAuthRelatedError,
  Qr as isAuthenticated,
  Ko as isDBError,
  Ri as isEntityEditable,
  Oa as isPbmPortalClient,
  Vo as isStaleEntry,
  jr as isTwoFARequired,
  Gr as login,
  zr as logout,
  Wr as matchesPathRules,
  Rc as mergeCustomTableColumnDefs,
  Fc as mergeVisibleAndHiddenColumnOrder,
  oo as neuClientHeadersForRequest,
  Jr as normalizePath,
  ct as parseJwtPayload,
  Pc as phone,
  co as queryClient,
  lo as queryKeys,
  Yr as registerCustomFields,
  Xr as registerEntityFormConfigs,
  Zr as registerFieldHandlers,
  ei as registerFieldHandlersFromRecord,
  ti as registerFormValidators,
  ni as removeTwoFAMethod,
  Ec as reorderColumnIDs,
  si as requestPasswordReset,
  ai as resetPasswordWithToken,
  ri as resolveFormViewMode,
  Fi as resolveFormViewModeByEditable,
  ii as resolveFormViewModeFromUserStore,
  oi as resolveIsSuperAdminFromUserStore,
  Oc as resolveNameTemplate,
  ci as resolvePrefillValues,
  li as resolveProps,
  Pi as resolveTemplateDefaults,
  di as runFormValidators,
  Aa as runInBackground,
  Bi as sanitizeTablePreferencesByKey,
  ui as sendTwoFACode,
  mi as sessionIsAdminLike,
  Qo as setEncrypted,
  jo as setEncryptedKV,
  Ei as setFormDraft,
  uo as setNeuClient,
  Go as setUnencrypted,
  zo as setUnencryptedKV,
  Lc as sortTokensToSorting,
  Mc as sortingToSortTokens,
  Wo as startGCDB,
  mo as suggestedFilenameFromContentDisposition,
  pi as syncTokenClaimsToUserStore,
  Co as toPresentableLabel,
  ar as transformAllToFormily,
  Ac as transformEntitySortQueryStringForQueryList,
  rr as transformToFormily,
  po as updateEntity,
  ht as useAPI,
  Pa as useAccessGuard,
  Oi as useApp,
  qt as useCanAccess,
  Ce as useChatStore,
  an as useConversations,
  Pe as useCurrentUserID,
  rc as useDebouncedSearchInput,
  Hi as useDefinition,
  Li as useDefinitionActions,
  ir as useDefinitionGuard,
  Mi as useDefinitionsStore,
  Ai as useEnhancedDefinitions,
  qi as useEntity,
  xi as useEntityDefinition,
  Ki as useEntityList,
  Ii as useEntityTabsStore,
  Vi as useFetchApi,
  Di as useFiltersStore,
  ki as useFormDraftsStore,
  at as useGuardStep,
  Ro as useInfiniteEntityList,
  hi as useLinkProvider,
  Zo as useLoadingStatusItem,
  ec as useLoadingStatusList,
  wn as useMessages,
  Ea as useNeuClient,
  Qi as usePaginatedEntityList,
  Nn as usePinActions,
  Sn as usePinnedMessages,
  Fo as useQueryMeta,
  rn as useRoomDetail,
  or as useSchemaWorker,
  Mn as useSendMessage,
  fi as useSubformRegistry,
  ji as useTablePreferencesStore,
  $ as useUserStore,
  $ as useUserStoreDefault,
  yi as validateToken,
  gi as validatorRegistry,
  _i as verifyTwoFACode,
  Jo as wipeDB
};
